import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AnimateModule, IPartnerCodeDetails, WwwAppState } from '@pro-connect/shared';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Clipboard } from '@angular/cdk/clipboard';
import { ToastrService } from 'ngx-toastr';
import { Angulartics2GoogleTagManager } from 'angulartics2';
import { select } from '@ngxs/store';

@Component({
  templateUrl: './partner-code-details-modal.component.html',
  styleUrls: ['./partner-code-details-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterModule, AnimateModule],
})
export class PartnerCodeDetailsModalComponent {
  public readonly codeDetails = input.required<IPartnerCodeDetails>();
  public readonly user = select(WwwAppState.user);
  private readonly _angulartics2GoogleTagManager = inject(Angulartics2GoogleTagManager);

  constructor(
    private readonly _ngbActiveModal: NgbActiveModal,
    private readonly _clipboard: Clipboard,
    private readonly _toastrService: ToastrService,
  ) {}

  public closeModal(): void {
    this._ngbActiveModal.close();
  }

  public onCopyToClipboard(): void {
    this._clipboard.copy(this.codeDetails()?.code || '');
    this._toastrService.success('Kod został skopiowany do schowka', 'Sukces');
  }

  public pushLayer(benefitName: string): void {
    this._angulartics2GoogleTagManager.pushLayer({
      event: 'uaevent',
      ecommerce: 'undefined',
      eventCategory: benefitName,
      eventAction: `select::${benefitName}`,
      eventLabel: this.user()?.type ? this.user()?.type : '',
      event_name: 'benefits_from_partners_step2',
    });
  }
}
